/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/eteraz',
  name: 'Eteraz',
  component: () => import('@/views/eteraz/Index'),



}]
